import React from "react";
import "./AdminHome.scss";
const AdminHome = () => {
  return <div>AdminHome</div>;
};

export default AdminHome;
